import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { i18n } from '../plugins/i18n';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import ForgottenPassword from '../views/ForgottenPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import PageNotFound from '../views/PageNotFound.vue';
import MyAccount from '../views/MyAccount.vue';
import RegisterFromInvite from '../views/RegisterFromInvite.vue';
import Transcriptions from '../views/Transcriptions.vue';
import CreateJob from '../views/CreateJob.vue';
import ViewJob from '../views/ViewJob.vue';
import Keywords from '../views/Keywords.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/invite/:userId/:inviteCode',
      name: 'registerFromInvite',
      component: RegisterFromInvite,
    },
    {
      path: '/forgotten-password',
      name: 'forgotten-password',
      component: ForgottenPassword,
    },
    {
      path: '/reset-password/:userId/:resetCode',
      name: 'reset-password',
      component: ResetPassword,
    },
    {
      path: '/',
      name: 'transcriptions',
      component: Transcriptions,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/create-job',
      name: 'create-job',
      component: CreateJob,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/view-job/:jobId',
      name: 'view-job',
      component: ViewJob,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/keywords',
      name: 'keywords',
      component: Keywords,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: MyAccount,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Handle language selection
  if (store.state.language.language && store.state.language.language !== i18n.locale) {
    i18n.locale = store.state.language.language;
  } else if (!store.state.language.language) {
    store.dispatch('language/setLanguage', navigator.languages)
      .then(() => {
        i18n.locale = store.state.language.language;
      });
  }
  const loggedIn = localStorage.getItem('user');
  // Check if route requires auth
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    // Redirect to login
    next('/login');
  } else {
    next();
  }
});

export default router;
